import './polyfills'; // Must be first import
import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import "./global.css";
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

// For development tools only
if (process.env.NODE_ENV === 'development') {
  window.React = React;
}

// Handle chunk loading errors (typically after deployments)
window.addEventListener('unhandledrejection', (event) => {
  const errorMessage = event.reason?.message || '';

  // Check if it's a chunk loading error
  if (errorMessage.includes('Loading chunk') ||
      errorMessage.includes('Failed to fetch dynamically imported module') ||
      errorMessage.includes('error loading dynamically imported module')) {

    console.warn('Chunk loading failed, clearing cache and reloading...');

    // Clear service worker cache if it exists
    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.getRegistrations().then(registrations => {
        registrations.forEach(registration => registration.unregister());
      });
    }

    // Clear localStorage flag to prevent infinite reload loop
    const reloadKey = 'chunk-reload-attempted';
    const reloadAttempted = sessionStorage.getItem(reloadKey);

    if (!reloadAttempted) {
      sessionStorage.setItem(reloadKey, 'true');
      // Reload the page to get fresh chunks
      window.location.reload();
    } else {
      // If already attempted reload, don't try again to prevent loop
      console.error('Chunk loading failed after reload. Please clear your browser cache manually.');
      sessionStorage.removeItem(reloadKey);
    }
  }
});

// Create root once
const rootElement = document.getElementById("root");
if (!rootElement) throw new Error('Failed to find the root element');
const root = createRoot(rootElement);

// Render app
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.unregister({
  onUpdate: (registration) => {
    console.log('New content is available; please refresh.');
    // You could show a notification to the user here
  },
  onSuccess: (registration) => {
    console.log('Content is cached for offline use.');
  },
});